import React from 'react';
import { Tooltip } from 'antd';
import {
  FlowContainer,
  EventBox,
  EventCount,
  Title,
  EventTitle,
  EventName,
  ErrorEventDisplay,
  ErrorEventCount,
  HoverIcon,
} from './styled';
import EventTooltip from './EventTooltip';
import { FlowEvents } from '../../types';

interface FlowChartProps {
  events: FlowEvents;
}

const FlowChart = ({ events }: FlowChartProps) => {
  const startEventName = events.start_event?.name;
  const successEventName = events.success_event?.name;
  return (
    <>
      <Title>Events</Title>
      <FlowContainer>
        <EventBox
          $type="start"
          title={
            events.start_event ? `Initial Event: ${startEventName}` : 'No start event configured'
          }
        >
          <EventTitle>Initial Event</EventTitle>
          {events.start_event && <EventName>{startEventName}</EventName>}
        </EventBox>

        <EventBox
          $type="success"
          title={
            events.success_event
              ? `Complete Event: ${successEventName}`
              : 'No success event configured'
          }
        >
          <EventTitle>Complete Event</EventTitle>
          {events.success_event && <EventName>{successEventName}</EventName>}
        </EventBox>

        <Tooltip
          title={<EventTooltip type="error" events={events} />}
          placement="bottom"
          color="#1f1f1f"
          styles={{ body: { padding: 0 } }}
          mouseEnterDelay={0.1}
          mouseLeaveDelay={0.1}
        >
          <EventBox $type="error">
            <EventTitle>Error Events</EventTitle>
            {events.error_event?.length ? (
              events.error_event.length === 1 ? (
                <EventName>{events.error_event[0].name}</EventName>
              ) : (
                <ErrorEventDisplay>
                  <ErrorEventCount>{events.error_event.length}</ErrorEventCount>
                  <span>events</span>
                  <HoverIcon />
                </ErrorEventDisplay>
              )
            ) : (
              <EventName>No error events</EventName>
            )}
          </EventBox>
        </Tooltip>
      </FlowContainer>
    </>
  );
};

export default FlowChart;
